export const TranslateTable = (table) => {
    switch (table) {
        case 'products':
            return 'Detalhes';
        case 'products_values':
            return 'Preços/Stocks';
        default:
            return table;
    }
}

export const TranslateAction = (action) => {
    switch (action) {
        case 'insert':
            return 'Inserção';
        case 'update':
            return 'Atualização';
        case 'delete':
            return 'Remoção';
        default:
            return action;
    }
}

export const TranslateLocation = (location) => {
    switch (location) {
        case 'products':
            return 'Produtos';
        default:
            return location;
    }
}